<template>
	<div class="orderTask"  >
		<div class="header_ContentBox p-l-10 p-r-10" >
			<i class="zb zb-enterprise Icon" ></i>
			<span class="header_text">/ 企业管理 / 人员认证签约</span>
		</div>
		<div class="content_Box box-shadow" :style="{'min-height': windowSizeHeight-120 +'px'}">
			<div class="p-l-10 p-r-10" style="height: 40px;">
				<div class="fl ">
					<span class="resetBtn m-r-5" >全部人员</span>
					<span class="resetBtn m-r-5">未签约</span>
					<!-- <span class="addOK">新增人员</span> -->
				</div>
				<div class="fr"  >
					<div class="search_box fl" style="">
						<div class="fl s_companyName">
							<el-input v-model="s_search" placeholder="姓名/身份证"></el-input>
						</div>
						<div class="fl s_type">
							<el-select v-model="s_type" placeholder="选择状态">
							    <el-option
									v-for="item in projectTypeArr"
									:key="item.id"
									:label="item.name"
									:value="item.id">
							    </el-option>
							</el-select>
						</div>
						<div class="fl s_submit cursor-pointer" @click="shearchBtn"> 搜索 </div> 
					</div>
				</div>
				
			</div>
			<template class="">
				<el-table :data="orderList" stripe style="width: 100%">
					<el-table-column label="姓名" width="220px">
						<template slot-scope="{row,$index}">
							<span class="font-Tahoma"></span>
						</template>
					</el-table-column> 
					<el-table-column label="手机号" :show-overflow-tooltip="true" min-width="120px">
						<template slot-scope="{row,$index}">
						 
						</template>
					</el-table-column>
					
					<el-table-column prop="money" label="身份证号" align="right" width="100px">
						<template slot-scope="{row,$index}">
							 
						</template>
					</el-table-column>
					
					<el-table-column label="银行卡号" :show-overflow-tooltip="true"  align="center" width="100px">
						<template slot-scope="{row,$index}">
						 
						</template>
					</el-table-column>
					<el-table-column prop="identity" label="银行名称" width="140px">
						<template slot-scope="{row,$index}">
							 
						</template>
					</el-table-column>
					<el-table-column  align="center" label="分行/支行" width="120px"  >
						<template slot-scope="{row,$index}">
							<span class="dd-state-0" v-if="row.order_status=='0'" >未接单</span>
							<span class="dd-state-1" v-if="row.order_status=='1'">已接单</span>
						</template>
					</el-table-column>
					<el-table-column  prop="created_at" label="签约状态" width="140px"  ></el-table-column>
					<el-table-column  prop="created_at" label="认证时间" width="140px"  ></el-table-column>
					<el-table-column  prop="created_at" label="签约日期" width="140px"  ></el-table-column>
					<el-table-column fixed="right" label="操作" width="120px">
						<template slot-scope="{row,$index}">
							<div v-if="row.order_status=='0'" >
								<a class="cz-font cz-dxtz cursor-pointer" @click="shortNote(row)">短信通知</a>
							</div>
							<div v-if="row.order_status=='1'" >
								<a class="cz-font cz-js cursor-pointer">订单详情</a>
							</div>
							
						</template>
					</el-table-column>
				</el-table>
				<!-- 分页 -->
				<div class="block regPagination" >
					<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNum"
					 :page-sizes="pageSize" :page-size="pageSizeNow" layout="total, sizes, prev, pager, next, jumper" :total="total">
					</el-pagination>
				</div>
			</template>
		</div>
		<!-- 发送短信弹框 -->
		<el-dialog title="短信通知" :visible.sync="noteShow" width="520px" :close-on-click-modal="false">
			<div class="diaCont">
				<div class="row-info clear">
					<div class="fl title-key">接单人：</div>
					<div class="fl list-cont"> {{ personInfo.name }} </div>
				</div>
				<div class="row-info clear p-t-10">
					<div class="fl title-key"><i class="zb zb-asterisk icon-wjx"></i>手机号：</div>
					<div class="fl list-cont">
						<el-radio-group v-model="mobileActive" >
						    <el-radio v-for="item in mobileArr" :label="item" :key="item">{{item}}</el-radio>
						 </el-radio-group>
					</div>
				</div>
				<div class="row-info clear p-t-10">
					<div class="fl title-key">短信内容：</div>
					<div class="fl list-cont"> 
						<el-input type="textarea" readonly :rows="4" v-model="noteContent" style="width:350px;"></el-input>
					</div>
				</div>
				<div class="clear"></div>
			</div>
			<div slot="footer" class="dialog-footer">
				<span class="btnOK m-r-20" @click="fs_noteBtn">发送</span>
				<span class="resetBtn" @click="noteShow=false">取消</span>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import {
		common
	} from '../../static/tool.js';
	export default {
		name: 'orderTask',
		data() {
			return {
				url: common.url,
				windowSizeHeight: document.documentElement.clientHeight, //浏览器可视化窗口的大小
				orderList:[],  //任务派单集合
				//	分页
				total: 0, //总数
				pageNum: 1, //当前页
				pageSize: [10, 20, 50, 100], //每页展示条数
				pageSizeNow: 20, //当前每页多少行
				/*搜索*/ 
				sid:'',  //员工ID 
				s_search:'', //姓名/身份证/手机号
				s_type:'', //类型
				projectTypeArr: [{ id: '0', name: '未接单'},{ id: '1',name: '已接单'} ],
				/*短信通知*/ 
				noteShow:false, //短信通知弹框
				mobileArr:[], //发送短信手机号数组
				mobileActive:'', //选定的手机号
				personInfo:{}, //短信通知 接单人详情
				noteContent:'【中服云】灵活用工平台：X先生/女士，******** 即将给您结算酬金，需您微信搜索“万多助手”小程序认证签约后才能结算。',
			}
		},
		created() {
			if (!sessionStorage.getItem('userInfo')) { //判断是否登录
				window.location = 'login.html';
				return;
			}
			
		},
		mounted() {
			this.startResult();
		},
		methods: {
			startResult() {
				
			},
			getOrderList(){
				let fn = new FormData();
				fn.append('pid', arguments[0]); 
				fn.append('sid', arguments[1]); 
				fn.append('page', arguments[2]); 
				fn.append('pageSize', arguments[3]); 
				fn.append('search', arguments[4]); 
				fn.append('order_status', arguments[5]); 
				fn.append('start_time', arguments[6]); 
				fn.append('end_time', arguments[7]); 
				fn.append('key', 'task'); 
				this.$http.post(this.url + '/zhongfy/company/OrderList', fn).then((res) => {
					if (res.data.code == '200' || res.data.msg == '成功') {
						let data = res.data.data;
						this.orderList = res.data.data;
						this.total = res.data.total;
					} else if (res.data.code == '8886') { //code   8886  登录过期
						sessionStorage.clear();
						this.$alert('登录已过期，请重新登录 !', '提示', {
							confirmButtonText: '确定',
							callback: action => {
								window.location = 'login.html';
							}
						});
						return;
					} else {
						this.$message.error(res.data.msg);
					}
				}, (res) => {
					this.$message.error('网络错误');
				})
			},
			
			// 搜索
			shearchBtn(){
				this.getOrderList(this.pid,this.sid,this.pageNum,this.pageSizeNow,this.s_search,this.s_type,this.startDate,this.endDate);
			},
			
			resetBtn() {  //全部订单
				
				this.getOrderList(this.pid,this.sid,this.pageNum,this.pageSizeNow,this.s_search,this.s_type,this.startDate,this.endDate);
			},
			abnormalOrders(){  //未签约
				this.s_type = '0';
				this.getOrderList(this.pid,this.sid,this.pageNum,this.pageSizeNow,this.s_search,this.s_type,this.startDate,this.endDate);
			},
			s_person(row){ //单个人搜索
				this.sid = row.sid;
				this.getOrderList(this.pid,this.sid,this.pageNum,this.pageSizeNow,this.s_search,this.s_type,this.startDate,this.endDate);
			},
			
			
			shortNote(row){  //短信通知
				this.personInfo = row;
				console.log(row);
				this.noteShow = true;
				let fn = new FormData();
				fn.append('sid', row.sid);
				this.$http.post(this.url + '/zhongfy/user/getMobile', fn).then((res) => {
					console.log(res);
					if ( res.data.code == '200') {
						this.mobileArr = res.data.data;
					} else if (res.data.code == '8886') { //code   8886  登录过期
						sessionStorage.clear();
						this.$alert('登录已过期，请重新登录 !', '提示', {
							confirmButtonText: '确定',
							callback: action => {
								window.location = 'login.html';
							}
						});
						return;
					} else {
						this.$message.error(res.data.msg);
						return;
					}
				}, (res) => {
					this.$message.error('网络错误！');
					return;
				})
			},
			fs_noteBtn(){ //发送短信
				if(this.mobileActive == ''){
					this.$message.error('请选择手机号！');
					return;
				}
				let fn = new FormData();
				fn.append('name',this.personInfo.name);
				fn.append('mobile',this.mobileActive);
				fn.append('enterprise_name',this.personInfo.enterprise_name);
				this.$http.post(this.url + '/zhongfy/company/NotifyingUser', fn).then((res) => {
					console.log(res);
					if (res.data.code == '200') {
						this.$message.success(res.data.msg);
						this.noteShow = false;
					} else if (res.data.code == '8886') { //code   8886  登录过期
						sessionStorage.clear();
						this.$alert('登录已过期，请重新登录 !', '提示', {
							confirmButtonText: '确定',
							callback: action => {
								window.location = 'login.html';
							}
						});
						return;
					} else {
						this.$message.error(res.data.msg);
						return;
					}
				}, (res) => {
					this.$message.error('网络错误！');
					return;
				})
			},
			
			handleCurrentChange(val) { //切换页数
				this.pageNum = val;
					this.getOrderList(this.pid,this.sid,this.pageNum,this.pageSizeNow,this.s_search,this.s_type,this.startDate,this.endDate);
			},
			handleSizeChange(val) { //切换每页条数
				this.pageSizeNow = val;
				this.pageNum = 1;
				this.getOrderList(this.pid,this.sid,this.pageNum,this.pageSizeNow,this.s_search,this.s_type,this.startDate,this.endDate);
			},
		},
		filters:{
			
		}
	}
</script>

<style scoped>
	.dialog-footer{text-align: left;padding-left: 90px;}
	.dialog-footer span{padding: 0 25px;}
	.list-cont input{width: 200px;}
	.search_box{width: 369px}
</style>



// WEBPACK FOOTER //
// src/components/PersonInfo.vue